"use client";
import React from "react";
import NewsTag from "./tag";
import Image from "next/image";
import { Sport } from "common";
import Card from "../primitives/card";
import Icon from "../primitives/icon";
import RelativeTime from "@/components/relative-time";
import SharePopover from "@/components/primitives/share";
import Button from "@/components/primitives/button";

interface ArticleProps {
  slug: string;
  title: string;
  img: string;
  league: Sport;
  date: string;
  children: React.ReactNode;
}
export default function NewsArticle(props: ArticleProps) {
  const leagueIcons: { [key: string]: string } = {
    nba: "basketball",
    nfl: "football",
    nhl: "hockey-puck",
    mlb: "baseball",
  };

  const icon: any = leagueIcons[props.league];
  const date = new Date(props.date).toLocaleString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  return (
    <>
      <Card className="!p-0">
        <div className="relative">
          <Image
            src={props.img}
            alt={props.title}
            unoptimized
            width={744}
            height={425}
          />
          <div className="absolute inset-0 z-10 flex items-start flex-col rounded-xl">
            <div className="px-6 py-5 flex flex-col gap-2 items-start justify-between w-full h-full">
              {/* Turn into component */}
              <div className="w-full flex flex-row justify-between items-center">
                <div className="flex gap-1 h-7 items-center text-title-sm-medium text-secondary-700 px-2 py-3 rounded-xl bg-[rgba(255,255,255,0.15)] backdrop-blur-[15.25px]">
                  <div className="uppercase">{props.league}</div>
                  <div>•</div>
                  <div>
                    <RelativeTime short date={props.date} />
                  </div>
                </div>
                <SharePopover
                  title={props.title}
                  url={`https://moneyline.com/news/${props.slug}`}
                  trigger={
                    <div className="flex gap-1 h-7 items-center text-title-sm-medium text-secondary-700 px-2 py-3 rounded-xl bg-[rgba(255,255,255,0.15)] backdrop-blur-[15.25px] cursor-pointer select-none">
                      Share <Icon name="share" size="sm" />
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="py-6 px-8 flex flex-col gap-8">{props.children}</div>
        <div className="py-6 px-10">
          <div className="flex flex-row gap-2 flex-wrap">
            <NewsTag label={props.league} icon={icon}></NewsTag>
            {/* <NewsTag label="portland trail blazers"></NewsTag>
          <NewsTag label="damian lillard"></NewsTag> */}
          </div>
        </div>
        <div className="pt-0 pb-6 px-10">
          <div className="flex flex-row justify-between items-center">
            <div className="flex flex-row items-center gap-2">
              <Icon
                variant="circle"
                name="monogram"
                size="sm"
                color="primary"
              />
              <div className="flex flex-col gap-1">
                <div className="text-title-sm-medium">Moneyline</div>
                <div className="flex gap-2 text-label-lg-medium text-secondary-400">
                  <span>{date}</span>
                </div>
              </div>
            </div>
            <SharePopover
              title={props.title}
              url={`https://moneyline.com/news/${props.slug}`}
              trigger={
                <Button variant="standard" size="sm" color="primary">
                  Share Article<Icon name="share" size="sm" />
                </Button>
              }
            />
            {/* <NewsShare /> */}
          </div>
        </div>
      </Card>
    </>
  );
}
